import {
  Box,
  styled,
  Grid,
  TableRow,
  TableCell,
  Button,
  tableCellClasses,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../../components/PageHeader';
import Table from '../../../components/Table';
import { Link } from 'react-router-dom';
import { CompanyDashboard } from '../../../schema/company';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';

const tableHead = [
  'รหัสบริษัท',
  'ชื่อบริษัท',
  'หมายเลขผู้เสียภาษี',
  'เบอร์โทรศัพท์',
  'อีเมล',
  'บุคคลภายใต้บริษัท',
  'Actions'
];

const CompanyManagement: React.FC = () => {
  const [companyData, setCompanyData] = useState<TableResponse<CompanyDashboard> | null>(null);

  const [filterCode, setFilterCode] = useState<string>('');
  const [filterID, setFilterID] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const searchParams = new URLSearchParams();
      if (filterName) {
        searchParams.set('company_name', `${filterName}`);
      }
      if (filterCode) {
        searchParams.set('company_code', `${filterCode}`);
      }
      if (filterID) {
        searchParams.set('company_id', `${filterID}`);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);
      api
        .get<TableResponse<CompanyDashboard>>(`/company/table`, { params: searchParams })
        .then((res) => {
          const { data } = res;
          setCompanyData(data);
        });
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [filterName, filterCode, filterID, page, rowsPerPage]);

  useEffect(() => {
    const searchParams = new URLSearchParams();
    searchParams.set('offset', `${0}`);
    searchParams.set('limit', `${10}`);
    api
      .get<TableResponse<CompanyDashboard>>(`/company/table`, { params: searchParams })
      .then((res) => {
        const { data } = res;
        setCompanyData(data);
      });
  }, []);

  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Container>
      <PageHeader text="จัดการข้อมูลบริษัท" />
      <Grid container spacing={2} marginTop={1}>
        <Grid item md={3}>
          <TextField
            label="ค้นหารหัสบริษัท"
            variant="outlined"
            placeholder="ค้นหารหัสบริษัท"
            onChange={(event) => setFilterCode(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="ค้นหาหมายเลขผู้เสียภาษี"
            variant="outlined"
            placeholder="ค้นหาหมายเลขผู้เสียภาษี"
            onChange={(event) => setFilterID(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item md={3}>
          <TextField
            label="ค้นหาชื่อบริษัท"
            variant="outlined"
            placeholder="ค้นหาชื่อบริษัท"
            onChange={(event) => setFilterName(event.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item md sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            component={Link}
            to="/company-management/create"
            variant="contained"
            color="primary"
          >
            เพิ่มข้อมูล
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={tableHead}
          count={companyData?.total ? companyData.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {companyData?.data.map((data, index) => (
            <TableRow key={index}>
              <TableCell align="center">{data.company_code}</TableCell>
              <TableCell align="center">{data.company_name}</TableCell>
              <TableCell align="center">{data.company_id}</TableCell>
              <TableCell align="center">{data.phone_number}</TableCell>
              <TableCell align="center">{data.email}</TableCell>
              <TableCell align="center">{data.person_count}</TableCell>

              <TableCell align="center">
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/company-management/${data.id}`}
                      variant="contained"
                      color="success"
                    >
                      ข้อมูล
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      component={Link}
                      to={`/company-management/${data.id}/edit`}
                      variant="contained"
                      color="warning"
                    >
                      แก้ไข
                    </Button>
                  </Grid>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </Container>
  );
};

export default CompanyManagement;

const Container = styled('div')`
  padding: 24px;
`;
